/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const TRANSITION_DATA_INVOICE_LOADING =
  'TRANSITION_DATA_INVOICE_LOADING';
export const TRANSITION_DATA_INVOICE_DATA = 'TRANSITION_DATA_INVOICE_DATA';
export const TRANSITION_DATA_CLAIM_DETAILS = 'TRANSITION_DATA_CLAIM_DETAILS';
export const TRANSITION_DATA_STATE_DATA = 'TRANSITION_DATA_STATE_DATA';
export const TRANSITION_DATA_COMPONENT_STATE =
  'TRANSITION_DATA_COMPONENT_STATE';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const SET_SUCCESS_MESSAGES = 'SET_SUCCESS_MESSAGES';
export const SET_SELECT_TYPE = 'SET_SELECT_TYPE';
export const SET_PLAN_TYPE = 'SET_PLAN_TYPE';
export const SET_REBATE_PROGRAM = 'SET_REBATE_PROGRAM';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_REBATE_PROGRAM_DD = 'SET_REBATE_PROGRAM_DD';
export const RESET_TRANSITION_DATA_STORE = 'RESET_TRANSITION_DATA_STORE';